export const commaSeparatedToArray = (str: string): string[] => {
  if (!str || str.trim() === '') {
    return [];
  }
  return str.split(',').map(item => item.trim());
};

export const arrayToCommaSeparated = (arr: (string | number | boolean)[], withSpaces?: boolean): string => {
  if (!arr || arr.length === 0) {
    return '';
  }
  return arr.join(withSpaces ? ', ' : ',');
};